import React from 'react';
import {T} from 'Actions/translate';
import {Grid, Card, Radio} from '@material-ui/core';
import BasicInput from 'Components/common/BasicInput';
import {PlaceOutlined, Warning} from '@material-ui/icons';
import Anchor from 'Components/common/Anchor';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';

class ShipToConfirm extends React.Component {
    state = {
        selectedValue: 1,
    };

    handleChangeRadio = (event) => {
        let value = event.target.value ? parseInt(event.target.value) : '';

        this.props.handleChangeRadio(value);
    };

    render() {
        const {shipToInfo, receiver, receiverTel, isProxyProcess} = this.props;
        let lang = loadLanguage();
        return (
            <Card className="ship-to-confirm">
                <Grid
                    className="ship-to-title-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="ship-to-title-left">
                        <Grid className="consignee-icon-grid" item>
                            <PlaceOutlined />
                        </Grid>
                        <Grid className="ship-to-title" item>
                            <span>{T('shipInfo')}</span>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    className="consignee-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="consignee-grid" item xs={11}>
                        <BasicInput
                            title={'shipToConsignee'}
                            testid="ship-to-consignee"
                            placeholder=""
                            defalutValue={receiver}
                            inputValid={this.props.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="ship-to-phone-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid className="ship-to-phone-grid" item xs={11}>
                        <BasicInput
                            title={'shipToPhone'}
                            testid="ship-to-phone"
                            placeholder=""
                            defalutValue={receiverTel}
                            inputValid={this.props.handleChange}
                            type="text"
                            required="true"
                            checkShipToPhone={true}
                            warningInfo={'please_input_correct_phone_number'}
                        />
                    </Grid>
                </Grid>

                {isProxyProcess ? (
                    <Grid
                        className="ship-to-num-container"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="ship-to-num-label" item xs={3}>
                            <span>{T('order_ship_to_number')}</span>
                        </Grid>
                        <Grid className="ship-to-num-content" item xs={9}>
                            <span>{shipToInfo ? shipToInfo.stNumber : ''}</span>
                        </Grid>
                    </Grid>
                ) : null}

                <Grid
                    className="address-container"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid
                        className="address-title-grid"
                        item
                        xs={lang === 'EN' ? 3 : 2}>
                        <span>{T('order_address')}</span>
                    </Grid>
                    <Grid
                        className="address-grid"
                        item
                        xs={lang === 'EN' ? 9 : 10}>
                        <span>
                            {shipToInfo
                                ? util.formatStAddress(
                                      shipToInfo.stCity,
                                      shipToInfo.stAddress,
                                      shipToInfo.stBuilding,
                                      shipToInfo.stDepartment,
                                  )
                                : ''}
                        </span>
                    </Grid>
                </Grid>
            </Card>
        );
    }
}

export default ShipToConfirm;
